"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _markdown = _interopRequireDefault(require("highlight.js/lib/languages/markdown"));

var _default = _markdown["default"];
exports["default"] = _default;